import React from 'react';
import { connect } from 'react-redux';
import { makeStyles, createStyles } from '@mui/styles';
import {
    List,
    ListItem,
    Tooltip,
    Box,
    IconButton,
    Typography
} from '@mui/material';
import { withRouter } from 'react-router-dom';
import {
    Dashboard,
    QueuePlayNext,
    QuestionAnswer,
    AccountBalance,
    AccessTimeFilled,
    GroupAdd,
    SpeakerGroup,
    IntegrationInstructions,
    SmartToy,
    Assignment,
    AssignmentInd,
    SettingsApplications
} from '@mui/icons-material';
import AutomationIcon from '@mui/icons-material/Assistant';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'; 
import { PapiroConsole } from 'src/utils/papiroConsole';

const useStyles = makeStyles(theme =>
    createStyles({
        compactMenu: {
            width: '100%',
            padding: '8px 0',
            backgroundColor: 'var(--mexx-bg-primary)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        menuItem: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '8px 0px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            width: '100%',
            minHeight: '85px',
            '&:hover': {
                '& $menuIcon': {
                    backgroundColor: '#A5D6A7',
                    borderColor: '#A5D6A7',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 2px 8px var(--mexx-green-light)',
                },
                '& $menuLabel': {
                    color: '#4CAF50',
                    fontWeight: 600,
                },
                '& $iconSvg': {
                    color: '#2E7D32',
                }
            }
        },
        menuIcon: {
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: 'var(--mexx-green-light)',
            border: '2px solid transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
        },
        iconSvg: {
            fontSize: '24px',
            color: 'var(--mexx-green-primary)',
            transition: 'color 0.3s ease',
        },
        menuLabel: {
            fontSize: '8px',
            fontWeight: 500,
            color: '#495057',
            textAlign: 'center',
            marginTop: '6px',
            lineHeight: 1.0,
            transition: 'all 0.2s ease',
            width: '110px',
            minHeight: '12px',
            maxHeight: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            whiteSpace: 'nowrap',
            overflow: 'visible',
            textOverflow: 'unset',
            zIndex: 10,
        },
        listItem: {
            padding: '6px 0',
            justifyContent: 'center',
            display: 'flex',
            width: '100%',
        },
        selectedItem: {
            position: 'relative',
            backgroundColor: 'var(--mexx-green-light)',
            borderLeft: '3px solid var(--mexx-green-primary)',
            '& $menuIcon': {
                backgroundColor: 'var(--mexx-green-light)',
                borderColor: 'var(--mexx-green-primary)',
                transform: 'translateY(-1px)',
                boxShadow: '0 2px 8px var(--mexx-green-light) ',
            },
            '& $menuLabel': {
                color: 'var(--mexx-green-dark) !important',
                fontWeight: '700 !important',
            },
            '& $iconSvg': {
                color: 'var(--mexx-green-dark) !important',
            }
        }
    })
);

const FreshdeskStyleMenu = (props) => {
    const classes = useStyles();
    const { history, match, userSession } = props;
    const [hoveredItem, setHoveredItem] = React.useState(null);
    const [selectedItem, setSelectedItem] = React.useState(null);
    
    let isAdm = false
    let isClient = true
    let isTec = false

    if (
        userSession != null &&
        userSession.user != null &&
        userSession.user.userrole != null
    ) {
        userSession?.user?.userrole.map((item, key) => {
            if (item.role.roletype != 3) {
                isClient = false;
            }

            if (
                item.role.roletype == 0 ||
                item.role.roletype == 1 ||
                item.role.roletype == 4
            ) {
                isAdm = true
            }
            if (item.role.roletype == 2) {
                isTec = true;
            }
        });
    }

    // Detecta qual item está ativo baseado na URL
    React.useEffect(() => {
        const currentHash = window.location.hash.replace('#', '');
        const hashToIdMap = {
            'dashboards': 'dashboard',
            'chamados': 'calleds',
            'agent-workspace': 'agentworkspace', 
            'comunicacao': 'communication',
            'usuarios': 'users',
            'organizacoes': 'organizations',
            'relatorios': 'reports',
            'administracao': 'admin'
        };

        const activeId = hashToIdMap[currentHash] || '';
        setSelectedItem(activeId);
    }, []);

    // Escuta mudanças no hash
    React.useEffect(() => {
        const handleHashChange = () => {
            const currentHash = window.location.hash.replace('#', '');
            const hashToIdMap = {
                'dashboards': 'dashboard',
                'chamados': 'calleds',
                'agent-workspace': 'agentworkspace', 
                'comunicacao': 'communication',
                'usuarios': 'users',
                'organizacoes': 'organizations',
                'relatorios': 'reports',
                'administracao': 'admin'
            };

            const activeId = hashToIdMap[currentHash] || '';
            setSelectedItem(activeId);
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    // Mapeamento dos principais menus para ícones - REDUZIDO
    const getMainMenuIcons = () => {
        // Verificar se userSession existe antes de usar
        let linkCalleds = `/${match.params.lang}/calleds`;
        //alert(props.userSession?.user.startpage)
        if (props.userSession?.user) {
            if (props.userSession.user.enablenewscreencalled) {
                linkCalleds = `/${match.params.lang}/new-calleds`;
            }
        }
        const mainMenuIcons = []

        mainMenuIcons.push(
            {
                id: 'dashboard',
                icon: Dashboard,
                label: 'Dashboard',
                tooltip: 'Dashboards e métricas',
                route: `/${match.params.lang}/dashboard`,
            }
        )
        mainMenuIcons.push(
            {
                id: 'calleds',
                icon: QueuePlayNext,
                label: 'Chamados',
                tooltip: 'Gestão de chamados e tickets',
                route: linkCalleds
            }
        )

        
        mainMenuIcons.push(
            {
                id: 'knowledgebase',
                icon: Assignment,
                label: 'Base de Conhecimento',
                tooltip: 'Base de conhecimento',
                route: isClient
                    ? `/${match.params.lang}/knowledgebases-client`
                    : `/${match.params.lang}/knowledgebases`
            }
        )

        if (props.userSession?.user && props.userSession.user.startpage) {
            const startpage = props.userSession.user.startpage
            PapiroConsole.log('startpage')
            PapiroConsole.log(startpage)
            if (startpage.indexOf("portal") > -1) {
                mainMenuIcons.push(
                    {
                        id: 'portal',
                        icon: QueuePlayNext,
                        label: 'Portal',
                        tooltip: 'Portal de atendimento',
                        route: `/${match.params.lang}/${startpage}`
                    }
                )
            } else if (startpage.indexOf("calendar") > -1 && !isClient) { 
                mainMenuIcons.push(
                    {
                        id: 'calendar',
                        icon: CalendarMonthIcon,
                        label: 'Calendário',
                        tooltip: 'Calendário',
                        route: `/${match.params.lang}/${startpage}`
                    }
                )
            } else if (startpage.indexOf("agent-workspace") > -1) {
                
            }
        }

        
        if (isTec) {
            mainMenuIcons.push(
                {
                    id: 'agentworkspace',
                    icon: AssignmentInd,
                    label: 'Minha Pauta',
                    tooltip: 'Minha pauta de atendimento',
                    route: `/${match.params.lang}/agent-workspace`
                }
            )
        }

        if (isAdm || isTec) {
            mainMenuIcons.push(
                {
                    id: 'communication',
                    icon: QuestionAnswer,
                    label: 'Comunicação',
                    tooltip: 'Chat, mensagens e canais',
                    route: `/${match.params.lang}/chat-attendance-list`
                }
            )
            mainMenuIcons.push(
                {
                    id: 'users',
                    icon: GroupAdd,
                    label: 'Clientes',
                    tooltip: 'Gestão de contatos',
                    route: `/${match.params.lang}/users-client`
                }
            )
        }

        mainMenuIcons.push(
            {
                id: 'admin',
                icon: SettingsApplications,
                label: 'Admin',
                tooltip: 'Configurações administrativas',
                route: `/${match.params.lang}/admin-menu#administracao`
            }
        )

        return mainMenuIcons
    };

    const handleIconClick = (route, itemId) => {
        // Atualiza imediatamente o item selecionado
        setSelectedItem(itemId);

        // Check if we're already on the admin-menu page
        const currentPath = window.location.pathname;
        const isOnAdminMenu = currentPath.includes('/admin-menu');

        //alert(route);
        if (isOnAdminMenu && route.indexOf('admin-menu') > -1) {
            // If already on admin-menu, just update the hash
            const hash = route.split('#')[1];
            if (hash) {
                // Force immediate hash change with proper format
                window.location.hash = '#' + hash;

                // Add small delay to ensure the hash is updated before triggering event
                setTimeout(() => {
                    window.dispatchEvent(new HashChangeEvent('hashchange'));
                }, 10);
            }
        } else {
            // Navigate to the route normally
            history.push(route);
        }
    };

    const mainIcons = getMainMenuIcons();

    return (
        <List component="nav" className={classes.compactMenu} disablePadding>
            {mainIcons.map((item, index) => (
                <ListItem key={index} className={classes.listItem}>
                    <Tooltip title={item.tooltip} placement="right">
                        <Box
                            className={`${classes.menuItem} ${selectedItem === item.id ? classes.selectedItem : ''}`}
                            onClick={() => handleIconClick(item.route, item.id)}
                        >
                            <Box className={classes.menuIcon}>
                                <item.icon
                                    className={classes.iconSvg}
                                />
                            </Box>
                            <Typography className={classes.menuLabel}>
                                {item.label}
                            </Typography>
                        </Box>
                    </Tooltip>
                </ListItem>
            ))}
        </List>
    );
};

const mapStateToProps = state => ({
    userSession: state.userSession,
});

export default withRouter(connect(mapStateToProps)(FreshdeskStyleMenu));